import { create } from 'zustand'

import { persist } from 'zustand/middleware'
 
export const useAuthStore = create(

  persist(

    (set) => ({

      loginResponse: null,

      setLoginResponse: (data) => set({ loginResponse: data }),

      clearLoginResponse: () => set({ loginResponse: null }),

    }),

    {

      name: 'login-response', // localStorage key

    }

  )

)
 